import { callAct, isOk } from './apiConfig';

/*
 * categories — the business's cuisine/style tags (ניהול העסק > קטגוריות), server-backed +
 * multi-tenant. Item shape: { id, name }.
 */
function normalize(row) {
    return { id: row.ID ?? row.id, name: row.name ?? '' };
}

export async function listCategories() {
    try {
        const envelope = await callAct('categoriesList', {});
        if (isOk(envelope) && Array.isArray(envelope.data)) return envelope.data.map(normalize);
    } catch (e) { /* act unavailable */ }
    return [];
}

export async function addCategory(name) {
    try {
        const envelope = await callAct('categoryAdd', { name });
        return { ok: isOk(envelope), id: envelope?.data?.ID };
    } catch (e) { return { ok: false }; }
}

export async function delCategory(id) {
    try {
        const envelope = await callAct('categoryDel', { ID: id });
        return { ok: isOk(envelope) };
    } catch (e) { return { ok: false }; }
}

export default { listCategories, addCategory, delCategory };
